import { createContext } from 'react';
import type { CommonTypes } from './helpers';

const NetworkContext = createContext<CommonTypes>({
  enableSSF: false,
  enableTimeSlice: false,
})

export default NetworkContext;
